<template>
    <el-button type="text" plain  icon="el-icon-setting" v-on:click="clickEvent()">{{btnCon}}</el-button>
</template>
  
  <script>
  
  export default {
    name: 'table-setting-button',
    props: {
      btnCon: {
            type: String,
            default: () => {
                return "设置"
            }
        },
    },
    data () {
      return {
      }
    },
    mounted () {
    },
    methods: {
        clickEvent(){
            this.$emit('select-type',1);
        }
    }
  }
  </script>
  
  <style lang="scss">
  </style>
  


// WEBPACK FOOTER //
// TableSettingButton.vue?7f35f909